import React from "react";
import "../../../../../Assets/Styles/DeleteAlert.scss";

const TimeoutModal = (props) => {
  return (
    <React.Fragment>
      <div
        className={
          window.localStorage.getItem("MenuIsOpen") === "1"
            ? "alert-overlay"
            : "alert-overlay alert-overlay-big"
        }
      >
        <div className="outline" onClick={() => props.Cancel()}></div>
        <div className="alert-body">
          <section className="alert-head">
            <p className="title">{props.AlertText}</p>
            <button onClick={() => props.Cancel()}>
              <i className="feather-x"></i>
            </button>
          </section>
          <p className="alert-text">{props.AlertInfo}</p>
          <div className="delete-footer alert-footer">
            <button className="cancel-btn" onClick={() => props.Cancel()}>
              {props.CancelText
                ? props.CancelText
                : props.translateText("cancel")}
            </button>
            <button
              className="delete-btn primary-blue-btn"
              onClick={() => props.Accept()}
            >
              {/* Continue */}
              {props.translateText("continue")}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TimeoutModal;
